import { Fragment } from "react";

import { DescriptionGrid, DescriptionGridItem } from "@/components/ui/DescriptionGrid";
import { ExpandedContent } from "@/components/ui/table-final-saviour/Table/TableExpandable";

type Props = {
    data: {
        "Descriptions Diagnosis 2": null | string;
        "Descriptions Diagnosis 3": null | string;
        "Descriptions Diagnosis 4": null | string;
        "Descriptions Description of Work": null | string;
    }[];
};

export const DescriptionsSection = (props: Props) => {
    const { data } = props;

    if (data.length === 0) {
        return null;
    }

    return (
        <ExpandedContent.Section>
            <ExpandedContent.Section.Content>
                <ExpandedContent.Section.Content.Title>Descriptions</ExpandedContent.Section.Content.Title>
            </ExpandedContent.Section.Content>
            <ExpandedContent.Section.Content>
                <DescriptionGrid colSpan={4}>
                    {data.map((row, index) => (
                        <Fragment key={index}>
                            {row["Descriptions Description of Work"] && (
                                <DescriptionGridItem title="Description of Work" colSpan={1} isValueMultiline>
                                    {row["Descriptions Description of Work"]}
                                </DescriptionGridItem>
                            )}
                            {row["Descriptions Diagnosis 2"] && (
                                <DescriptionGridItem title="Diagnosis 2" colSpan={1} isValueMultiline>
                                    {row["Descriptions Diagnosis 2"]}
                                </DescriptionGridItem>
                            )}
                            {row["Descriptions Diagnosis 3"] && (
                                <DescriptionGridItem title="Diagnosis 3" colSpan={1} isValueMultiline>
                                    {row["Descriptions Diagnosis 3"]}
                                </DescriptionGridItem>
                            )}
                            {row["Descriptions Diagnosis 4"] && (
                                <DescriptionGridItem title="Diagnosis 4" colSpan={1} isValueMultiline>
                                    {row["Descriptions Diagnosis 4"]}
                                </DescriptionGridItem>
                            )}
                        </Fragment>
                    ))}
                </DescriptionGrid>
            </ExpandedContent.Section.Content>
        </ExpandedContent.Section>
    );
};
